import React from 'react';
import { regex } from '@capsovision/capso_utils';
import Request from '../AxiosInstance';
import * as yup from 'yup';
import {useFormik} from 'formik';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import Tooltip from '@mui/material/Tooltip';
import TextsmsIcon from '@mui/icons-material/Textsms';
import EmailIcon from '@mui/icons-material/Email';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import StateSelect from '../UI/StateSelect';



export default function ConfirmInfoForm ({formState, handleSubmit, handleBack}) {

	const validationSchema = yup.object({
		address: yup
			.string()
			.required(),
		address2: yup
			.string(),
		city: yup
			.string()
			.required(),
		zip: yup
			.string()
			.required()
			.matches(regex.zip, 'Zip format is invalid'),
		email: yup
			.string()
			.matches(regex.email, 'Please check the format of your email'),
		phone: yup
			.string()
			.matches(regex.usphone, 'Invalid phone number format, must be 10 digits number like 1002003000')
	});

	const formSubmit = async (formValue) => {

		const combinedFormValue = {
			...formValue,
			receiver: formValue.method === 'text' ? formValue.phone : formValue.email
		}

		await Request.post('/auth/getrc', combinedFormValue);
		handleSubmit(combinedFormValue);
	}

	const formik = useFormik({
		initialValues: formState,
		validationSchema: validationSchema,
		onSubmit: async (values) => {
			await formSubmit(values);
		},
	});

	return (
		<React.Fragment>
			<Typography variant="h6" align={"center"} sx={{ pt: 2, pb: 1 }}>
				{formik.values.fullName}, Confirm your address and contact
			</Typography>
			<form onSubmit={formik.handleSubmit}>
				<Typography variant={"subtitle1"} sx={{ pb: 2 }}>
					Please provide correct address for capsule delivery
				</Typography>
				<Grid container spacing={2}>
					<Grid item xs={12} sm={6}>
						<TextField
							required
							id="address"
							name="address"
							label="Address 1"
							fullWidth
							autoComplete="shipping address-line1"
							variant="outlined"
							value={formik.values.address}
							onChange={formik.handleChange}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextField
							id="address2"
							name="address2"
							label="Address 2 (Optional)"
							fullWidth
							autoComplete="shipping address-line2"
							variant="outlined"
							value={formik.values.address2}
							onChange={formik.handleChange}
						/>
					</Grid>
					<Grid item xs={12} sm={4}>
						<TextField
							required
							id="city"
							name="city"
							label="City"
							fullWidth
							autoComplete="shipping address-level2"
							variant="outlined"
							value={formik.values.city}
							onChange={formik.handleChange}
						/>
					</Grid>
					<Grid item xs={12} sm={4}>
						<StateSelect
							required
							id="state"
							name="state"
							autoComplete="shipping address-level1"
							value={formik.values.state}
							onChange={formik.handleChange}
						/>
					</Grid>
					<Grid item xs={12} sm={4}>
						<TextField
							required
							id="zip"
							name="zip"
							label="Zip code"
							fullWidth
							autoComplete="shipping postal-code"
							variant="outlined"
							value={formik.values.zip}
							onChange={formik.handleChange}
						/>
					</Grid>
				</Grid>
				<Divider variant="middle" sx={{ mt: 2 }} />
				<Typography variant={"subtitle1"} sx={{ pt: 1, pb: 2 }}>
					Choose a login method
				</Typography>
				<Grid container spacing={2}>
					<Grid item xs={12} align="center">
						<ToggleButtonGroup
							color="primary"
							id="method"
							name="method"
							value={formik.values.method}
							exclusive
							onChange={(event, newValue) => {
								if (newValue && newValue !== formik.values.method) {
									formik.setFieldValue('method', newValue);
									formik.setFieldValue('receiver', '');
								}
							}}
						>
							<ToggleButton value="text">
								<Tooltip title={"Text Message"}>
									<TextsmsIcon/>
								</Tooltip>
							</ToggleButton>
							<ToggleButton value="email">
								<Tooltip title={"Email"} >
									<EmailIcon/>
								</Tooltip>
							</ToggleButton>
						</ToggleButtonGroup>
					</Grid>

					<Grid item xs={12} >
						{formik.values.method === 'text' ? (
							<TextField
								margin="normal"
								required
								fullWidth
								id="phone"
								label="Phone"
								name="phone"
								autoComplete="phone"
								autoFocus
								value={formik.values.phone}
								onChange={formik.handleChange}
								error={formik.touched.phone && Boolean(formik.errors.phone)}
								helperText={formik.touched.phone && formik.errors.phone}
							/>
						) : (
							<TextField
								margin="normal"
								required
								fullWidth
								id="email"
								label="Email"
								name="email"
								autoComplete="email"
								autoFocus
								value={formik.values.email}
								onChange={formik.handleChange}
								error={formik.touched.email && Boolean(formik.errors.email)}
								helperText={formik.touched.email && formik.errors.email}
							/>
						)}
					</Grid>
				</Grid>
				<Typography variant={"subtitle2"} sx={{ pb: 2 }}>
					We will send you a temporary verification code to confirm your contact.
				</Typography>
				<Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
					<Button
						variant="outlined"
						color="warning"
						sx={{ mt: 3, ml: 1 }}
						onClick={handleBack}
					>
						Back
					</Button>
					<Button
						variant="contained"
						sx={{ mt: 3, ml: 1 }}
						type="submit"
					>
						Next
					</Button>
				</Box>
			</form>
		</React.Fragment>
	);
}